import React from "react";
import { EventType } from "./types";

const showGalleryIcon = require("../styles/images/ShowGallery.svg");
const shareIcon = require("../../../../app/assets/images/share-icon.svg");
const privacyIcon = require("../../../../public/images/icon-change-privacy.svg");
const manageEvent = require("../../../../public/images/icon-manage-event.svg");

interface BreadcrumbEventActionsProps {
  selectedEvent: EventType;
  setActiveShareModalEventId: (id: number | null) => void;
  setMarkUploadPopupId?: (id: number | null) => void;
  setPrivacyPopupId: (id: number | null) => void;
  context: any;
}

const BreadcrumbEventActions: React.FC<BreadcrumbEventActionsProps> = ({
  selectedEvent,
  setActiveShareModalEventId,
  setMarkUploadPopupId,
  setPrivacyPopupId,
  context
}) => {
  return (
    <div className={`ws-album-actions-header geo-access-${selectedEvent?.userAccessLevel}`}>
      {setMarkUploadPopupId && (
        <div className="ws-desktop-header">
          {selectedEvent.uploadCompleteStatus ? (
            <div className="event-up-done ws-actions-right-border">
              <span className="event-up-check pop-check"></span>
              <span className="event-up-donetext">Upload complete</span>
            </div>
          ) : (
            selectedEvent.markUploadCompleteURL != null &&
            selectedEvent.uploadCompleteStatus != null && (
              <div className="ws-leads-count ws-actions-right-border">
                <span
                  className="ws-event-up-link"
                  onClick={e => {
                    e.stopPropagation();
                    setMarkUploadPopupId(selectedEvent.id);
                  }}
                >
                  Mark upload complete
                </span>
                {selectedEvent.waitingCustomerLeadsCount > 0 && (
                  <div className="ws-event-wait">
                    {selectedEvent.waitingCustomerLeadsCount === 1 ? (
                      <span>
                        <b>1 person</b> is waiting
                      </span>
                    ) : (
                      <span>
                        <b>{selectedEvent.waitingCustomerLeadsCount} people</b> are
                        waiting
                      </span>
                    )}{" "}
                  </div>
                )}
              </div>
            )
          )}
        </div>
      )}

      <div className="ws-album-actions ws-album-list-actions ws-actions-left-border">
        {selectedEvent.canShare && (
          <span
            id={`share-icon-${selectedEvent.id}`}
            className="ws-action-button view"
            onClick={e => {
              e.stopPropagation();
              setActiveShareModalEventId(selectedEvent.id);
            }}
            data-toggle="tooltip"
            data-placement="bottom"
            onMouseEnter={() =>
              context.showActionTooltip(selectedEvent.id, "Share Event", "share")
            }
          >
            <img src={shareIcon} />
            <span className="ws-icon-sub">Share</span>
          </span>
        )}

        {selectedEvent.canUpdatePrivacy && (
          <span
            className="ws-action-button view"
            onClick={e => {
              e.stopPropagation();
              setPrivacyPopupId(selectedEvent.id);
            }}
            id={`privacy-icon-${selectedEvent.id}`}
            data-toggle="tooltip"
            data-placement="bottom"
            onMouseEnter={() =>
              context.showActionTooltip(
                selectedEvent.id,
                "Update Privacy",
                "privacy"
              )
            }
          >
            <img src={privacyIcon} />
            <span className="ws-icon-sub">Privacy</span>
          </span>
        )}

        <a
          id={`manage-icon-${selectedEvent.id}`}
          href={
            selectedEvent.canAccessManageEventPage
              ? selectedEvent.manageEventPath
              : "javascript:void(0);"
          }
          className={`ws-action-button view ${
            !selectedEvent.canAccessManageEventPage ? "disabled" : ""
          }`}
          onClick={e => {
            if (!selectedEvent.canAccessManageEventPage) e.preventDefault();
            e.stopPropagation();
          }}
          data-toggle="tooltip"
          data-placement="bottom"
          title={
            selectedEvent.canAccessManageEventPage
              ? "Manage Event"
              : "You don't have access"
          }
          onMouseEnter={() =>
            context.showActionTooltip(
              selectedEvent.id,
              selectedEvent.canAccessManageEventPage
                ? "Manage Event"
                : "You don't have access",
              "manage"
            )
          }
        >
          <img src={manageEvent} alt="Manage Event" />
          <span className="ws-icon-sub">Manage</span>
        </a>

        <a
          id={`view-icon-${selectedEvent.id}`}
          href={(() => {
            try {
              return selectedEvent?.browsePhotosURL ? new URL(selectedEvent.browsePhotosURL).pathname : "#";
            } catch (error) {
              console.warn("Invalid browsePhotosURL:", selectedEvent?.browsePhotosURL);
              return "#";
            }
          })()}
          target="_blank"
          className="ws-open-gallery-icon ws-action-button"
          onClick={e => e.stopPropagation()}
          data-toggle="tooltip"
          data-placement="bottom"
          onMouseEnter={() =>
            context.showActionTooltip(
              selectedEvent.id,
              "View Event Gallery",
              "view"
            )
          }
        >
          <img src={showGalleryIcon} alt="Show Photos" />
          <span className="ws-icon-sub">View</span>
        </a>
      </div>
    </div>
  );
};

export default BreadcrumbEventActions;
